module.exports = __webpack_public_path__ + "img/webkaifa.86542e35.png";